import type { TFunction } from "i18next";
import { useTranslation } from "react-i18next";
import { AiFeature, AiUsageFunction } from "../../../autogen/bff-api";

export const aiFeatureLabels = (t: TFunction): Record<AiFeature, string> => ({
  [AiFeature.Assistant]: t("The assistant"),
  [AiFeature.CpvSuggestions]: t("CPV suggestions"),
  [AiFeature.NeedTypeSuggestion]: t("Need type suggestion"),
  [AiFeature.AwardLetterDraft]: t("Award letter drafts"),
  [AiFeature.TextDraft]: t("AI drafts in text fields"),
  [AiFeature.Autofill]: t("Autofill from document"),
  [AiFeature.DocumentReading]: t("Reading documents"),
  [AiFeature.CreateFromDocument]: t("Create contract or project with AI"),
  [AiFeature.BidInsight]: t("Bid insight"),
});

export const aiUsageFunctionLabels = (t: TFunction): Record<AiUsageFunction, string> => {
  const features = aiFeatureLabels(t);
  return {
    [AiUsageFunction.Assistant]: features[AiFeature.Assistant],
    [AiUsageFunction.CpvSuggestions]: features[AiFeature.CpvSuggestions],
    [AiUsageFunction.NeedTypeSuggestion]: features[AiFeature.NeedTypeSuggestion],
    [AiUsageFunction.AwardLetterDraft]: features[AiFeature.AwardLetterDraft],
    [AiUsageFunction.TextDraft]: features[AiFeature.TextDraft],
    [AiUsageFunction.Autofill]: features[AiFeature.Autofill],
    [AiUsageFunction.DocumentReading]: features[AiFeature.DocumentReading],
    [AiUsageFunction.CreateFromDocument]: features[AiFeature.CreateFromDocument],
    [AiUsageFunction.BidInsight]: features[AiFeature.BidInsight],
    [AiUsageFunction.DocumentChat]: t("Fency document chat"),
    [AiUsageFunction.DocumentSearch]: t("Fency document search"),
    [AiUsageFunction.ContractSearch]: t("Fency contract search"),
    [AiUsageFunction.Unknown]: t("Unknown AI function"),
  };
};

export const useAiFeatureLabels = () => aiFeatureLabels(useTranslation().t);

export const useAiUsageFunctionLabels = () => aiUsageFunctionLabels(useTranslation().t);
